<template>
  <div class="vip-pay">
    <template v-if="canSelectPayType">
      <img
        v-if="!inVip"
        class="vip-guarantee-ad clickable"
        src="@/assets/images/ca/vip-home/vip-guarantee-ad.png"
        alt=""
        @click="toVipBuy()"
      />
      <el-button v-else type="primary" @click="handleVipPay">
        立即缴纳
      </el-button>
      <div v-if="showVipPayError" class="text-danger m-t-4">
        会员保证金额度不足，无法缴纳
      </div>
    </template>
    <div class="vip-guarantee-illustrate">
      <div class="illustrate-title">会员保证金担保说明</div>
      <ol>
        <li>
          会员保证金担保与会员套餐等级直接关联，不同等级享有不同担保额度；
        </li>
        <li>
          套餐中规定的保证金担保仅适用于询比类型的项目，其它项目不支持使用；
        </li>
        <li>
          保证金担保额度可循环使用，使用后一般在项目结束时恢复额度；
        </li>
        <li>
          会员保证金担保只用于在保证额度以内的项目，超出保证金额度的项目，企业需要全额现金缴纳该项目保证金。
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { depositStatusDict } from '@/dictionary/project/common'
import { toVipBuy } from '@/utils/platform'
import { strToThousands } from '@/utils/utils'
import { useInquiryGuaranteeVipPayApi } from '@/api/supplier/inquiry'

export default {
  name: 'GuaranteeVipPay',

  props: {
    guaranteeInfo: {
      type: Object,
      default: () => {}
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    tradeId: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      // 控制会员保证金缴纳错误信息显示
      showVipPayError: false
    }
  },

  computed: {
    ...mapState('user', ['vipInfo', 'vipGuarantee']),
    ...mapGetters('user', ['inVip', 'vipCode']),

    payStatus() {
      return this.guaranteeInfo.payStatus
    },

    // 是否能选择保证金缴纳方式
    canSelectPayType() {
      return this.payStatus <= depositStatusDict.PENDING.value
    }
  },

  methods: {
    toVipBuy,

    /**
     * 使用会员保证金缴纳
     */
    handleVipPay() {
      const guaranteeFee = this.guaranteeInfo.guaranteeFee
      const guaranteeFeeStr = strToThousands(guaranteeFee)
      if (this.vipGuarantee.remain < Number(guaranteeFee)) {
        this.showVipPayError = true
      } else {
        this.showVipPayError = false

        this.$systemConfirm(
          h => (
            <div>
              当前操作需扣除会员保证金担保额度
              <span class='text-danger'>{guaranteeFeeStr}元</span>
              ，是否确认本次操作？
            </div>
          ),
          '会员保证金担保扣除提示'
        ).then(result => {
          if (!result) return

          const postData = {
            avsProductCode: this.vipCode,
            totalQuota: this.vipGuarantee.total,
            remainQuota: this.vipGuarantee.remain
          }
          useInquiryGuaranteeVipPayApi(this.orderId, this.tradeId, postData)
            .then(res => {
              this.$emit('refresh')
            })
            .catch(err => {
              if (err?.message) this.$message.error(err.message)
            })
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.vip-guarantee-ad {
  display: block;
  height: 92px;
}

.vip-guarantee-illustrate {
  background: $info-sixth-color;
  border: 1px solid $info-fourth-color;
  border-radius: 4px;
  padding: 20px;
  font-size: 12px;
  color: $second-text-color;
  margin-top: 16px;

  .illustrate-title {
    color: $text-color;
    @include text-bold;
    margin-bottom: 8px;
  }

  ol {
    margin: 0;
    padding: 0 0 0 12px;

    li {
      line-height: 2;
    }
  }
}
</style>
